import React from 'react';
import './ResultsStates.css';

export interface ResultsEmptyProps {
  /** Message personnalisé (défaut : « Aucun résultat pour votre recherche »). */
  message?: string;
}

/**
 * État « aucun résultat » du bottom sheet (SPEC §4.4).
 * Purement présentationnel.
 */
export const ResultsEmpty: React.FC<ResultsEmptyProps> = ({
  message = 'Aucun résultat pour votre recherche',
}) => {
  return <p className="results-empty">{message}</p>;
};

export default ResultsEmpty;
